/// <reference path="../../../node_modules/sweetalert2/sweetalert2.d.ts" />
import Swal from "sweetalert2";
import "jquery";

var xhrNumber = 0;

export default function init() {
    window.addEventListener("load", function () {
        initSelectEvents();

        window.onpopstate = function (e: any) {
            if (e.state) {
                $("#pagesAppend").html(e.state.content).hide().fadeIn();

                document.title = e.state.pageTitle;

                $("#marketCode").val(e.state.marketCode);

                $(".js-page-link")
                    .off("click")
                    .click(function () {
                        search($(this), false, true);
                    });
            }
        };

        search(1, true, false);
    });

    function initSelectEvents() {
        $("#marketCode").change(function () {
            let val = $("#marketCode").val();
            if (val) {
                search(1, false, false);
            }
        });
    }

    function search(page: any, replaceState: boolean, jumpToTop: boolean) {
        let marketCode = $("#marketCode").val();
        let pageContentGuid = $("#pageContentGuid").val();

        if (jumpToTop === true) {
            $("html, body").animate(
                {
                    scrollTop: $("#pagesAppend").offset().top,
                },
                500
            );
        }
        // Just do the search if countries and markets dropdown attend condition
        if (!!marketCode) {
            $(".salesServiceBlock, .emptyServiceCentres, #paginationNav").remove();
            $("#locationsLoader").removeClass("d-none");
            let language = $("#hiddenLanguageCode").val();
            // Used for just render the last ajax call
            let seqNumber = ++xhrNumber;
            $.get("/locationslistpage/locationpages/", {
                marketCode: marketCode,
                pageContentGuid: pageContentGuid,
                page,
                language: language,
            })
                .done(function (data) {
                    if (xhrNumber === seqNumber) {
                        $(
                            ".salesServiceBlock, .emptyServiceCentres, #paginationNav"
                        ).remove();
                        $("#locationsLoader").removeClass("d-none");
                        $("#pagesAppend").html(data).hide().fadeIn();

                        let title = document.title;

                        if (!replaceState) {
                            history.pushState(
                                {
                                    content: data,
                                    pageTitle: title,
                                    marketCode: marketCode,
                                },
                                title,
                                "?marketCode=" + marketCode
                            );
                        } else {
                            history.replaceState(
                                {
                                    content: data,
                                    pageTitle: title,
                                    marketCode: marketCode,
                                },
                                title,
                                "?marketCode=" + marketCode
                            );
                        }
                    }
                })
                .fail(function (error) {
                    if (xhrNumber === seqNumber) {
                        Swal.fire("Oops...", error.statusText, "error");

                        $("#pagesAppend").fadeIn();
                    }
                })
                .always(function () {
                    if (xhrNumber === seqNumber) {
                        $("#locationsLoader").addClass("d-none");
                    }
                });
        }
    }
}
init();
